<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tMR0Cb/tc-custom/9780062308481.jpg?1718106015346" alt="This image is the cover for the book Last Dragon Charmer: Quest Maker, The Last Dragon Charmer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Dragon Charmer: Quest Maker, The Last Dragon Charmer
      </h1>
      <p class="bookDescription body article font2">
        <p>This second book in the epic Last Dragon Charmer series is perfect for fans of Soman Chainani’s School for Good and Evil and Chris Colfer’s Land of Stories.  </p><p>When mysterious magic transported Prince Caden from the Greater Realm to seemingly normal Asheville, North Carolina, he was shocked to discover it was home to the most dangerous villains ever banished from his homeland. And that a great and powerful Elderdragon rules them all. </p><p>Now Caden suspects that dark forces are conspiring on both sides of the magical divide between his world, and this one. The Elderdragon gives Caden a quest: uncover the dangerous plan and protect the Greater Realm from banished villains hungry for revenge. Because if they find a way home before Caden can, everyone he loves may be in danger. </p><p>With its perfect blend of wit, action, and heart, Laurie McKay’s Last Dragon Charmer series will captivate readers young and old, and remind them what it truly means to be a hero.</p><p><b>“A sometimes-amusing, sometimes-thrilling, and always entertaining sequel.” —Kirkus Reviews</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laurie McKay
      </h2>
      
      <p class="authorDescription body article"><P>Laurie McKay lives in Durham, North Carolina, with her family and her two dogs. She earned her bachelor&#39;s degree in biology from the University of North Carolina at Chapel Hill and her master&#39;s degree in biological oceanography from North Carolina State University. She&#39;s taught at the Chesapeake Bay Governor&#39;s School for Marine and Environmental Science and in the North Carolina community college system. When she&#39;s not dodging students and prepping lab activities, she&#39;s sitting at a local coffee shop and daydreaming about all things fantastical.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05795f3a